<template>
  <div>
    <section class="hero hero-lp hero-valentine has-background-primary">
      <div class="hero-body">
        <div class="container">
          <div class="columns pt-5 pb-5 is-vcentered is-variable is-1" v-if="$whitelabel.short.toLowerCase() === 'adac'">
            <div class="column is-6-tablet is-6-desktop is-7-widescreen has-text-centered-mobile titlearea">
              <h1 class="title has-background-secondary is-inline-block is-size-4 is-size-3-tablet is-size-2-desktop has-text-weight-bold has-text-white pr-1 pl-1 mb-5">
                ADAC Hotelgutschein
              </h1>
              <h2 class="title valentine-title is-size-3 is-size-1-tablet has-text-weight-bold has-text-black">
                Angebote zum Verlieben!
              </h2>
              <p class="has-text-weight-bold is-size-5-touch is-size-4-desktop is-size-4-widescreen is-size-3-fullhd has-text-black" style="line-height:1.2">Ausgewählte Kurzurlaube für <br />Ihre romantische Auszeit</p>
            </div>
            <div class="column has-text-centered">
              <img importance="high" :src="`https://assets.urlaubsgutschein.kaufen/i/resize?width=700&quality=50&type=auto&interlace=true&file=whitelabel/adac/campaigns/valentinstag.png`" alt="Valentinstag" width="600" height="295" />
            </div>
          </div>

          <!-- <div class="columns" v-if="$whitelabel.short.toLowerCase() !== 'adac'">
            <div class="column is-7-tablet is-6-desktop has-text-centered-mobile titlearea">
              <h1 class="title has-background-white has-text-black is-inline-block is-size-5 is-size-4-tablet is-size-3-desktop has-text-weight-bold is-uppercase u-pl15 u-pr15 u-p05">
                Black Friday Week
              </h1>
              <h2 class="subtitle has-text-white">
                21. November – 29.November
              </h2>
              <p class="has-text-white-ter has-text-weight-bold is-size-5">Ausgewählte Kurzurlaube nochmals deutlich reduziert!</p>
            </div>
            <div class="column has-text-centered">
              <img
                importance="high"
                :src="`https://assets.urlaubsgutschein.kaufen/i/resize?width=500&quality=50&type=auto&interlace=true&file=whitelabel/_assets/images/campaigns/black-friday.png`"
                :srcset="
                  `https://assets.urlaubsgutschein.kaufen/i/resize?width=500&quality=50&type=auto&interlace=true&file=whitelabel/_assets/images/campaigns/black-friday.png 500w,
                            https://assets.urlaubsgutschein.kaufen/i/resize?width=370&quality=50&type=auto&interlace=true&file=whitelabel/_assets/images/campaigns/black-friday.png 370w,
                            https://assets.urlaubsgutschein.kaufen/i/resize?width=280&quality=50&type=auto&interlace=true&file=whitelabel/_assets/images/campaigns/black-friday.png 280w`
                "
                sizes="(max-width: 500px) 100vw, 400px"
                alt="Black Friday Week"
                width="400"
                height="300"
              />
            </div>
          </div> -->
        </div>
      </div>
    </section>

    <section class="section has-background-white is-hidden-mobile advantages-lp">
      <div class="container">
        <Advantages v-bind:size="'small'" class="mb-4" />
      </div>
    </section>

    <section class="section has-background-white">
      <div class="container">
        <div class="columns">
          <div class="column is-8 is-offset-2" v-if="$whitelabel.short.toLowerCase() === 'adac'">
            <h2 class="title">Angebote zum Verlieben – bis zu 70% günstiger</h2>
            <!-- <h3 class="subtitle has-text-weight-bold">subtitle</h3> -->
            <div class="content">
              <p>
                Verlängern Sie das Fest der Liebe und schenken Sie Ihrer Liebsten oder Ihrem Liebsten in diesem Jahr etwas Besonderes! Mit einem Gutschein von ADAC Hotelgutschein machen Sie so nicht nur Ihrem Herzensmenschen ein Geschenk, sondern kommen auch selbst in den Genuss eines exklusiven
                Hotelaufenthalts.
              </p>
              <p>
                Residieren Sie im Schlosshotel, genießen Sie 4 Sterne-Luxus oder nehmen Sie sich eine romantische Wellness-Auszeit. Sichern Sie sich noch bis zum 20.02. unsere günstigen, nochmals reduzierten Valentins-Deals und lösen Sie diese flexibel innerhalb der nächsten 3 Jahre ein. Kaufen,
                drucken, unbezahlbare Vorfreude schenken!
              </p>
            </div>
          </div>

          <!-- <div class="column is-8 is-offset-2" v-if="$whitelabel.short.toLowerCase() !== 'adac'">
            <h2 class="title">Jetzt schon an Weihnachten denken</h2>
            <div class="content">
              <p>
                Ab 21. November 2020 ist es soweit: Wir starten in die <strong>Black Friday Woche!</strong> Sparen Sie bis zum 29.11. nochmals auf unsere bereits deutliche reduzierten Hotelgutscheine. Lassen Sie sich diese Chance nicht entgehen und sichern Sie sich einen Urlaubsgutschein für Ihren
                nächsten Kurzurlaub oder kaufen Sie bereits jetzt ein Weihnachtsgeschenk für Ihre Liebsten. Unsere Black Friday Angebote finden Sie hier.
              </p>
            </div>
          </div> -->
        </div>
      </div>
    </section>
    <section class="section section-offers">
      <div class="container">
        <div v-if="offers.length == 0">
          <NoOffer />
          <!-- <div class="column is-8 is-offset-2">
            <div class="notification is-info is-size-4 has-text-centered u-p2 has-text-light has-text-weight-semibold">
              <b-icon icon="sad-cry" size="is-large"></b-icon>
              <br />Leider sind keine Angebote vorhanden!
            </div>
          </div> -->
        </div>

        <div v-if="offers.length > 0">
          <h2 class="title is-size-4 has-text-centered">Angebote enden in</h2>
          <CountdownTimer :endTime="campaignTimer" class="has-text-centered timer-lp mb-5" />

          <!-- bzw für normale suche haspromotion | Custom:valentine -->

          <div class="columns is-multiline is-variable is-5 mt-5">
            <div class="column is-half-tablet is-one-third-desktop is-flex" v-for="o in offers" :key="o.id">
              <OfferElement :product="o" class="offer--valentine" />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Advantages from '@/components/Advantages'
import CountdownTimer from '@/components/CountdownTimer'
import OfferElement from '@/components/OfferElement'
import OfferApi from '@/api/offer-api'

const NoOffer = () => import(/* webpackPrefetch: true , webpackChunkName: "nooffer" */ '@/components/NoOffer')

export default {
  name: 'valentine',
  components: {
    Advantages,
    CountdownTimer,
    OfferElement,
    NoOffer,
  },
  data() {
    return {
      offers: [],
    }
  },
  computed: {
    campaignTimer: function() {
      let endDate = new Date('2022-02-20 23:59') - new Date()
      return endDate
    },
  },
  async mounted() {
    this.offers = await OfferApi.getOffersWithCustomPromotion('valentin22')
  },
  metaInfo() {
    return {
      title: 'Angebote zum Verlieben – bis zu 70% günstiger',
      meta: [{name: 'description', content: 'Am 14. Februar ist Valentinstag. Schenken Sie in diesem Jahr einen ADAC Hotelgutschein!'}],
      //link: [{rel: 'preconnect', href: '//maps.googleapis.com', crossorigin: 'anonymous'}],
    }
  },
}
</script>

<style lang="scss">
.hero-valentine {
  //background-color: red;
  .hero-body {
    @media screen and (max-width: 768px) {
      padding: 0;
    }
  }
}

.valentine-title {
  @media screen and (min-width: 1024px) {
    font-size: 3.7rem !important;
  }
  @media screen and (min-width: 1216px) {
    font-size: 4.2rem !important;
  }

  @media screen and (min-width: 1408px) {
    font-size: 4.2rem !important;
  }
}

.offer--valentine {
  .card-tag .tag {
    background-color: red !important;
  }
}
</style>
